import { Component, OnInit ,Output,EventEmitter,Input} from '@angular/core';
import {
  SmartAssetRecommendation,
  SmartAssetRecommendationResults,
} from 'src/app/layout/models/smart-asset-recommendation';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { AssetModel, AssetWithDuplicatesModel, ScannedAssetDetailModel,AssetSnoozeModel } from 'src/app/property/models/new-asset.model';
import { TosterService } from 'src/app/core/services/toster/toster.service';

@Component({
  selector: 'app-snooze-asset-recommendations',
  templateUrl: './snooze-asset-recommendations.component.html',
  styleUrls: ['./snooze-asset-recommendations.component.scss']
})
export class SnoozeAssetRecommendationsComponent implements OnInit {

  constructor(private assetService: AssetService,private tosterService:TosterService) { }

    @Output() closeEvent = new EventEmitter();
    @Output() refreshRecomendations = new EventEmitter();
    @Input() assetId!: string; 
    @Input() maintenanceCycle: string; 
    @Input() selectedAsset: SmartAssetRecommendation; 
    @Input() actionPerformDate: string; 
    isAssetListLoading: boolean = false;
    isSnoozeEnabled: boolean = true;
    filteredTimePeriod: { id: number, name: string }[] = [];
    isProcessing: boolean = false;
    timePeriod = [
    { id: 1, name: '1 Day' },
    { id: 2, name: '1 Week' },
    { id: 3, name: '2 Weeks' },
    { id: 4, name: '1 Month' },
    { id: 5, name: '2 Months' },
    { id: 6, name: '3 Months' }
    ];
    public assetSnoozeModel: AssetSnoozeModel = new AssetSnoozeModel();
    selectedTimePeriod: number;
    ngOnInit(): void { 
     
      this.getSnoozeOptions(this.selectedAsset.nextCycleEndDate);
    }



    getSnoozeOptions(maintenanceEndDate: Date) {
    try
    {
        this.isSnoozeEnabled = true;
        const currentDate = new Date();
        var endDate = new Date(maintenanceEndDate)
        const msInDay = 1000 * 60 * 60 * 24;
        const daysUntilMaintenance = Math.ceil((endDate.getTime() - currentDate.getTime()) / msInDay);
      
        if (daysUntilMaintenance > 1 && daysUntilMaintenance <= 7) {
          this.filteredTimePeriod = [this.timePeriod[0]]
        } else if (daysUntilMaintenance > 7 && daysUntilMaintenance <= 14) {
          this.filteredTimePeriod = [this.timePeriod[0], this.timePeriod[1]]; 
        } else if (daysUntilMaintenance > 14 && daysUntilMaintenance <= 32) {
          this.filteredTimePeriod = [this.timePeriod[0], this.timePeriod[1], this.timePeriod[2]]; 
        } else if (daysUntilMaintenance > 32 && daysUntilMaintenance < 180) {
          this.filteredTimePeriod = [this.timePeriod[0], this.timePeriod[1], this.timePeriod[2], this.timePeriod[3], this.timePeriod[4],this.timePeriod[5]]; 
        } else if (daysUntilMaintenance >= 180 &&  daysUntilMaintenance < 730) {
          this.filteredTimePeriod = [this.timePeriod[0], this.timePeriod[1], this.timePeriod[2], this.timePeriod[3], this.timePeriod[4], this.timePeriod[5]]; 
        }  else {
          this.filteredTimePeriod = []; 
          this.tosterService.error("Snooze option is unavailable as the maintenance cycle has ended.");
          this.isSnoozeEnabled = false;
        }
    }
    catch(ex) 
    {
      console.error("Error in getSnoozeOptions: ", ex);
      this.tosterService.error("An error occurred while calculating snooze options.");
    }
  }

  public dismiss() {
      this.closeEvent.emit();
  }
  public snooze() {
    this.isProcessing = true;
    if(this.selectedTimePeriod === undefined || this.selectedTimePeriod === null) 
    {
      this.tosterService.error("Please select a time period to snooze the recommendation.");  
    }
    else
    {
        this.assetSnoozeModel = 
        {
          assetId: this.selectedAsset.assetId,
          timePeriod: this.selectedTimePeriod
        };
        this.assetService.snoozeAssetRecommendation(this.assetSnoozeModel).subscribe({
        next: (res) => {
          this.tosterService.success('Recommendation snoozed successfully');
          this.refreshRecomendations.emit();
          this.dismiss();
        },
        error: (err) => {
        
        }
    });

    }
    this.isProcessing = false;
  }
}
